import { generatePath } from 'react-router-dom';
import { RouteSegments } from '../routingClientAdmin.interface';
import { generateScheduleProfileRoute } from './generateScheduleProfileRoute';

export const generateScheduleProfileIntervalRoute = (id: number, intervalIndex?: number) => {
  const index = Number.isNaN(intervalIndex) ? null : String(intervalIndex);
  return generatePath(
    `${generateScheduleProfileRoute()}/${RouteSegments.Schedule.Interval}`,
    { id: String(id), index },
  );
};
